import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, TextField, Card, LayoutStack } from '@ui/index';
import { useAuth } from '../hooks/useAuth.mock';
import styles from './Login.module.css';

export function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const { error } = await signIn(email, password);
      if (error) {
        setError(error.message);
      } else {
        navigate('/');
      }
    } catch (err) {
      setError('An unexpected error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <Card className={styles.card}>
        <LayoutStack spacing="large" align="center">
          <h1>Admin Login</h1>
          
          <form onSubmit={handleSubmit} className={styles.form}>
            <LayoutStack spacing="medium">
              <TextField
                type="email"
                label="Email"
                value={email}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                required
              />
              <TextField
                type="password"
                label="Password"
                value={password}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                required
              />
              {error && (
                <div className={styles.error}>
                  {error}
                </div>
              )}
              <Button type="submit" disabled={loading}>
                {loading ? 'Signing In...' : 'Sign In'}
              </Button>
            </LayoutStack>
          </form>
        </LayoutStack>
      </Card>
    </div>
  );
}
